import { render, staticRenderFns } from "./external.vue?vue&type=template&id=698aac35&scoped=true"
import script from "./external.vue?vue&type=script&lang=js"
export * from "./external.vue?vue&type=script&lang=js"
import style0 from "./external.vue?vue&type=style&index=0&id=698aac35&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "698aac35",
  null
  
)

export default component.exports